/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { getFullNameUser, getRestoLogin, refreshPage, removeUserSession } from "../../Helpers/Utils/Common";
import { 
  // getName, 
  getRole, 
  getRoleName 
} from "../../Helpers/Utils/Common";
import MenuItem from "./MenuItem";
import { useNavigate } from "react-router-dom";
import { logoutUser, resyncData } from "../../Helpers/apiCalls/authApi";
import toast from "react-hot-toast";
import { LogoutOutlined } from "@ant-design/icons";
import { Button } from "antd";


//css
import "./NavbarAdmin.css";

//icons
// import logout from "../../Assets/Images/logout.png";
import board from "../../Assets/Images/board.png";
import category from "../../Assets/Images/category.png";
import file from "../../Assets/Images/file.png";
import user from "../../Assets/Images/user.png";
import paperclip from "../../Assets/Images/paperclip.png";
import discount from "../../Assets/Images/hot-sale.png";
import briqueLogo from "../../Assets/Images/dreamnest_with_header.png";
import ettasLogo from "../../Assets/Images/ettasLogo.png";
import checkoutCart from "../../Assets/Images/checkout-cart.png";

const systemLogo = getRestoLogin()==="dreamnest"?briqueLogo:ettasLogo;

const NavbarAdmin = (props) => {
  const navigate = useNavigate();
  const userRole = getRole();
  const restoType = getRestoLogin();
  const userRoleName = getRoleName();
  const userFullName = getFullNameUser();
  //ADMIN
  const adminManagerItems = [
    {
      name: "Closed Invoices",
      exact: true,
      to: "/closedinvoices",
      iconClassName: paperclip,
      expand: true,
    },
    {
      name: "Menus",
      exact: true,
      to: "/menuManager",
      iconClassName: board,
      expand: true,
    },
    {
      name: "Reports",
      exact: true,
      to: "/",
      iconClassName: file,
      subMenus: [
        // { name: "Sales", to: "/sales-report" },
        { name: "Receiving Report", to: "/receiving-report" },
        { name: "Category Report", to: "/category-report" },
        // restoType==="dreamnest"&&{ name: "Resto Item Sales Report", to: "/resto-item-sales-report" },
        { name: "EJournal", to: "/ejournal-report" },
        { name: "Sales", to: "/sales-report" },
        { name: "Payment Report", to: "/payment-report" },
        { name: "Item History", to: "/item-history-report" },
        { name: "Senior Citizen Sales", to: "/senior-discounts-sales-report" },
        { name: "PWD Sales", to: "/pwd-discounts-sales-report" },
        { name: "Other Discount Sales", to: "/other-discounts-sales-report" },
        { name: "Cancelled Reports", to: "/cancelled-report" },
        { name: "Cash Counts", to: "/cash-counts-report" },
        { name: "Audit Trails", to: "/audit-trails-report" },
        { name: "X Reading", to: "/x-reading-report" },
        { name: "Z Reading Report", to: "/z-reading-report" },
        { name: "Daily Sales Report", to: "/daily-sales-report" },
      ],
      expand: true,
    },
    {
      name: "Categories",
      exact: true,
      to: "/categoryManager",
      iconClassName: category,
      expand: true,
    },
    {
      name: "Discounts",
      exact: true,
      to: "/discountsManager",
      iconClassName: discount,
      expand: true,
    },
    {
      name: "Users",
      exact: true,
      to: "/userManager",
      iconClassName: user,
      expand: true,
    },
    {
      name: "Ordering Station",
      exact: true,
      to: "/orderingpage",
      iconClassName: checkoutCart,
      expand: true,
    },
  ];

  const ownerManagerItems = [
    {
      name: "Closed Invoices",
      exact: true,
      to: "/closedinvoices",
      iconClassName: paperclip,
      expand: true,
    },
    {
      name: "Menus",
      exact: true,
      to: "/menuManager",
      iconClassName: board,
      expand: true,
    },
    {
      name: "Reports",
      exact: true,
      to: "/",
      iconClassName: file,
      subMenus: [
        // { name: "Sales", to: "/sales-report" },
        { name: "Receiving Report", to: "/receiving-report" },
        { name: "Category Report", to: "/category-report" },
        // restoType==="dreamnest"&&{ name: "Resto Item Sales Report", to: "/resto-item-sales-report" },
        { name: "EJournal", to: "/ejournal-report" },
        { name: "Sales", to: "/sales-report" },
        { name: "Payment Report", to: "/payment-report" },
        { name: "Item History", to: "/item-history-report" },
        { name: "Senior Citizen Sales", to: "/senior-discounts-sales-report" },
        { name: "PWD Sales", to: "/pwd-discounts-sales-report" },
        { name: "Other Discount Sales", to: "/other-discounts-sales-report" },
        { name: "Cancelled Reports", to: "/cancelled-report" },
        { name: "Cash Counts", to: "/cash-counts-report" },
        { name: "Audit Trails", to: "/audit-trails-report" },
        { name: "X Reading", to: "/x-reading-report" },
        { name: "Z Reading Report", to: "/z-reading-report" },
        { name: "Daily Sales Report", to: "/daily-sales-report" },
      ],
      expand: true,
    },
    {
      name: "Categories",
      exact: true,
      to: "/categoryManager",
      iconClassName: category,
      expand: true,
    },
    {
      name: "Discounts",
      exact: true,
      to: "/discountsManager",
      iconClassName: discount,
      expand: true,
    },
    {
      name: "Users",
      exact: true,
      to: "/userManager",
      iconClassName: user,
      expand: true,
    },
  ];

  const supManagerItems = [
    {
      name: "Closed Invoices",
      exact: true,
      to: "/closedinvoices",
      iconClassName: paperclip,
      expand: true,
    },
    {
      name: "Reports",
      exact: true,
      to: "/",
      iconClassName: file,
      subMenus: [
        { name: "Receiving Report", to: "/receiving-report" },
        { name: "Category Report", to: "/category-report" },
        { name: "EJournal", to: "/ejournal-report" },
        { name: "Sales", to: "/sales-report" },
        { name: "Payment Report", to: "/payment-report" },
        { name: "Item History", to: "/item-history-report" },
        { name: "Senior Citizen Sales", to: "/senior-discounts-sales-report" },
        { name: "PWD Sales", to: "/pwd-discounts-sales-report" },
        { name: "Other Discount Sales", to: "/other-discounts-sales-report" },
        { name: "Cancelled Reports", to: "/cancelled-report" },
        { name: "Cash Counts", to: "/cash-counts-report" },
        { name: "Audit Trails", to: "/audit-trails-report" },
        { name: "X Reading", to: "/x-reading-report" },
      ],
      expand: true,
    },
   
    {
      name: "Ordering Station",
      exact: true,
      to: "/orderingpage",
      iconClassName: checkoutCart,
      expand: true,
    },
  ];

  const staffItems = [
    {
      name: "Closed Invoices",
      exact: true,
      to: "/closedinvoices",
      iconClassName: paperclip,
      expand: true,
    },
    
    {
      name: "Ordering Station",
      exact: true,
      to: "/orderingpage",
      iconClassName: checkoutCart,
      expand: true,
    },
    
  ]

  // logout handler
  async function handleLogout() {
    const response = await logoutUser(restoType);
    if (response.data) {
      toast.success("Logging out...")
      setTimeout(() => {
        removeUserSession();
        navigate("/");
        refreshPage();
      }, 500)
    }
  }

  // logout handler
  async function handleResync() {
    const response = await resyncData();
    if (response.data) {
      toast.success("Resync Successfully")
    } else {
      toast.success("Resync Unsuccessfully")
    }
  }

  const [inactive, setInactive] = useState(true);
  const [menuItems, setMenuItems] = useState([]);

  const handleExpand = (index) => {
    var list = [...menuItems];

    if (!inactive) {
      for (var i = 0; i < list.length; i++) {
          if (list[i] && i !== index) {
            list[i]["expand"] = true;
          }
      }

      list[index]["expand"] = !list[index]["expand"];

      setMenuItems(list);
    }
  };

  useEffect(() => {
    if (inactive) {
      removeActiveClassFromSubMenu();
    }

    props.onCollapse(inactive);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inactive]);

  const removeActiveClassFromSubMenu = () => {
    document.querySelectorAll(".sub-menu").forEach((el) => {
      el.classList.remove("active");
    });
  };

  useEffect(() => {
    if (userRole === "1") {
      setMenuItems(adminManagerItems)
    } else if (userRole==="4") {
      setMenuItems(ownerManagerItems)
    } else if (userRole==="2") {
      setMenuItems(supManagerItems)
    } else {
      setMenuItems(staffItems)
    }

    let menuItemsList = document.querySelectorAll(".menu-item");
    menuItemsList.forEach((el, index) => {
      if (menuItems[index].name === props.active) {
        el.classList.add("active");
      }
      el.addEventListener("click", (e) => {
        const next = el.nextElementSibling;
        removeActiveClassFromSubMenu();
        menuItemsList.forEach((el) => el.classList.remove("active"));
        el.classList.toggle("active");
        if (next !== null) {
          next.classList.toggle("active");
        }
      });
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`side-menu ${inactive ? "inactive" : ""}`}>
      <div className="top-section">
        <div className="logo d-flex justify-content-center">
          <img
            src={systemLogo}
            className="navbar-logo"
            onClick={() => {
              // had to do this part because maguba ang expandable menu items if iclose ang navbar while they are open
              if (userRole === "1") {
                setMenuItems(adminManagerItems)
              } else if (userRole==="4") {
                setMenuItems(ownerManagerItems)
              } else if (userRole==="2") {
                setMenuItems(supManagerItems)
              } else {
                setMenuItems(staffItems)
              }
              setInactive(!inactive)
            }
            }
          />
        </div>
      </div>

      <div className={inactive ? "main-menu" : "main-menu active-menu"}>
        {menuItems.map((menuItem, index) => {
          if (menuItem) {
            return (
              <MenuItem
                key={index}
                name={menuItem.name}
                exact={menuItem.exact.toString()}
                to={menuItem.to}
                subMenus={menuItem.subMenus || []}
                iconClassName={menuItem.iconClassName}
                expandManage={menuItem.expand}
                setExpandManage={handleExpand}
                index={index}
                activeSub={menuItem.name === props.active}
                onClick={(e) => {
                  if (inactive) {
                    setInactive(false);
                  }
                }}
              />
            )
          }
        })}
      </div>
      <div className="side-menu-footer mb-5">
      {!inactive && (
          <div className="user-details-footer ms-4">
            { process.env.REACT_APP_BRIQUE_API !== 'https://dreamnest-pos-api.qrave.ph/' ?
              (
                  <>
                    <span>
                      <Button
                        className="resync-btn"
                        onClick={handleResync}
                      >
                        RESYNC
                      </Button>
                    </span>
                    {/* LOCAL */}
                    <span className="user-type-label bolder">v 1.4.4</span>
                  </>
              ) : (
                  <>
                      {/* CLOUD */}
                      <br/>
                      <span className="user-type-label bolder">v 1.2.1</span>
                  </>
              )

            }
            
            <br/>
            <span className="navbar-user-label">{userFullName?.toUpperCase()}</span>
            <br />
            <span className="user-type-label">{userRoleName?.toUpperCase()}</span>
          </div>
        )}
          <div
            className="logout-cont"
            onClick={() => handleLogout()}
          >
            <LogoutOutlined className="footer-icon"/>
            <span className="logout-label">LOGOUT</span>
          </div>
      </div>
    </div>
  );
};

export default NavbarAdmin;
